<template>
  <div class="crestron-logs mt-4 ml-8 mr-8">
    <v-container fluid>
      <v-row>
        <v-col cols="4">
          <h1 class="display-2 mb-5">Crestron Logs</h1>
        </v-col>
      </v-row>
      <v-card color="default" outlined class="elevation-0">
        <v-card-text>
          <remote-data-table
            :url="'backoffice/crestron-logs'"
            :search-enabled="true"
            :headers="headers"
            :filters="filters"
            :sort-by="'-created_at'"
            ref="crestronLogsDatatable"
          >
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | formatDateTime }}
            </template>
            <template v-slot:item.host="{ item }">
              {{ item.host }}
            </template>
            <template v-slot:item.type="{ item }">
              <v-chip v-if="item.type === 'info'" color="info" label small>
                Info
              </v-chip>
              <v-chip
                v-else-if="item.type === 'error'"
                color="error"
                label
                small
              >
                Fehler
              </v-chip>
              <v-chip v-else color="warning" label small>
                Warnung
              </v-chip>
            </template>
          </remote-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import RemoteDataTable from "@/components/RemoteDataTable";
import moment from "moment";

export default {
  components: { RemoteDataTable },

  data: () => ({
    headers: [
      { text: "ID", align: "left", sortable: true, value: "id" },
      {
        text: "Erstellt am",
        align: "left",
        sortable: true,
        value: "created_at"
      },
      { text: "host", align: "left", sortable: true, value: "host" },
      { text: "Nachricht", align: "left", sortable: false, value: "message" },
      { text: "Type", align: "left", sortable: true, value: "type" }
    ],
    filters: [
      {
        type: "select",
        field: "type",
        label: "Typ",
        values: [
          { text: `Eingehend`, value: "in" },
          { text: "Ausgehend", value: "out" }
        ],
        default: "out"
      },
      {
        type: "datepicker",
        field: "date",
        label: "Datum",
        default: moment()
      }
    ]
  }),

  methods: {}
};
</script>

<style></style>
